/* eslint-disable max-len */
export const esES = {
  all: "Todos",
  auth: {
    account_merge_required: "Se requiere unificar la cuenta",
    errors: {
      email_already_in_use: "Este correo electrónico ya está en uso",
      invalid_email: "Correo electrónico inválido",
      popup_blocked: "Ventana emergente bloqueada",
      too_many_requests: "Demasiadas solicitudes",
      user_disabled: "Usuario deshabilitado",
      user_not_found: "Usuario no encontrado",
      weak_password: "Contraseña muy débil",
    },
    login_with_apple: "Iniciar sesión con Apple",
    login_with_facebook: "Iniciar sesión con Facebook",
    login_with_google: "Iniciar sesión con Google",
    password_reset_sent: "Correo de restablecimiento enviado",
  },
  common: {
    close_modal: "Cerrar modal",
  },
  company: {
    load_error: "Error de carga",
  },
  company_info: {
    closed_now: "Cerrado ahora",
    more_info: "Más información",
    open_now: "Abierto ahora",
  },
  dashboard: {
    bookings: {
      actions: {
        cancel: "Cancel",
        confirm: "Confirmar",
        deny: "Denegar",
        edit: "Editar",
        view: "View",
      },
      bulk: {
        cancel: "Cancel",
        confirm: "Confirm",
        selected: "Selected",
      },
      bulk_update_fail: "Bulk update fail",
      bulk_update_partial_fail: "Bulk update partial fail",
      cancel: "Cancel",
      cancel_booking: "Cancel booking",
      cancel_fail: "No pudimos cancelar su reserva, inténtelo de nuevo",
      choose_time: "Elija un horario",
      columns: {
        actions: "Acciones",
        customer_email: "Correo electrónico del cliente",
        customer_name: "Nombre del cliente",
        datetime: "Fecha de la reserva",
        seats: "Asientos",
        status: "Estado",
      },
      concierge: {
        back: "Volver",
        booked: "Reservado en",
        camera_error: "Camera error",
        camera_generic_error: "Camera generic error",
        camera_not_found: "Camera not found",
        camera_permission_denied: "Camera permission denied",
        closereader: "Cierre el lector",
        cod: "Código",
        confirm: "Confirmar reserva",
        confirmed: "Personas confirmadas",
        contact: "¿Alguna duda? Póngase en contacto con el gerente o administrador.",
        hello: "¡Hola Sr. Conserje!",
        is_invalid: "Esta reserva está fuera de su período de uso.",
        last_scan_id: "id: {{booking_id}}",
        loading: "Cargando datos de la reserva...",
        mail: "Correo electrónico",
        name: "Nombre",
        not_found: "Reserva no encontrada",
        openreader: "Abra el lector",
        phone: "Teléfono",
        recomendation: "¡Por favor, lea otro código QR e inténtelo de nuevo!",
        remain: "Restan",
        scancode: "Leyendo código QR de la reserva",
        scanned: "Reserva leída",
        seatsfor: "Asientos para",
        state: "Estado",
        switch_camera: "Cambiar cámara",
        usereader: "Use el lector de abajo para leer el código de reserva.",
      },
      created_at: "Created at",
      created_fail: "No pudimos crear una nueva reserva, inténtelo de nuevo.",
      created_success: "¡Nueva reserva creada!",
      customer: {
        bookings: "Sus reservas",
        complete: "Perfil completo",
        email: "Hemos enviado un correo de confirmación, revise su bandeja de entrada.",
        menu: "Menú",
        none: "Usted no tiene ninguna reserva.",
        profile_updated: "¡Perfil actualizado con éxito!",
        qr_info: "Su reserva fue enviada a su correo, pero también puede verla haciendo clic en 'Ver código QR'.",
        qr_modal_description: "Muestre este código QR en el restaurante para confirmar su reserva.",
        qr_modal_title: "Código QR de la Reserva",
        title: "Reservas",
        view_qr: "Ver código QR",
      },
      delete_success: "¡Reserva cancelada!",
      dialogs: {
        confirmed: {
          message: "¿Desea confirmar la reserva de '{{booking_title}}' asientos? ",
          success: "¡Reserva confirmada!",
          title: "Confirmar reservas",
        },
        edit: "Editar reserva",
        fail: {
          message: "¡Algo salió mal cuando intentamos confirmar esta reserva, inténtelo de nuevo!",
          title: "¡Ops!",
        },
      },
      edit_booking: "Edit booking",
      empty_suggestion: "Empty suggestion",
      filters: {
        all_status: "All status",
        date: "Date",
        date_range: "Date range",
        filters: "Filters",
        search: "Busca",
        search_placeholder: "Buscar reservas...",
        status: "Estado de la reserva",
      },
      final_status: "El estado de esta reserva ya no se puede cambiar.",
      how_many: "¿Mesa para cuántas personas?",
      load_error: "Load error",
      no_availability: "No availability",
      no_bookings_concierge: "No bookings concierge",
      no_bookings_customer: "No bookings customer",
      no_date: "No se pudo cargar la información disponible para la fecha seleccionada, seleccione otra fecha e inténtelo de nuevo.",
      notes: "Notes",
      people_count: "People count",
      refresh_error: "Refresh error",
      reservation: "Reservation",
      showing_count: "Showing count",
      status: {
        all: "All",
        canceled: "Cancelada",
        cancelled: "Cancelled",
        completed: "Completed",
        confirmed: "Confirmada",
        created: "Esperando confirmación",
        denied: "Negada",
        noshow: "No asistió",
        partial: "Esperando llegada de clientes ",
        pending: "Pending",
        used: "Ya utilizada",
      },
      status_error: "Status error",
      status_label: "Status label",
      table: {
        actions: "Actions",
        customer: "Customer",
        datetime: "Datetime",
        id: "Id",
        seats: "Seats",
        status: "Status",
      },
      title: "Lista de Reservas",
      total_count: "Total count",
      update_fail: "Update fail",
      weekdays: {
        friday: "Vie",
        monday: "Lun",
        saturday: "Sáb",
        sunday: "Dom",
        thursday: "Jue",
        tuesday: "Mar",
        wednesday: "Mié",
      },
    },
    categories: {
      actions: {
        delete: "Eliminar",
        disable: "Deshabilitar",
        edit: "Editar",
        enable: "Habilitar",
      },
      columns: {
        actions: "Acciones",
        description: "Descripción",
        langs: "Idiomas registrados",
        name: "Nombre",
        order: "Orden",
        status: "Estado",
      },
      dialogs: {
        delete: {
          message: "¿Realmente desea eliminar la categoría '{{category_name}}'?",
          title: "Eliminar categoría",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        all_languages_required: "Todos los idiomas son obligatorios",
        basic_info: "Información Básica",
        create_title: "Nueva Categoría",
        edit_title: "Editar Categoría",
        description: "Descripción",
        enabled: "Habilitar",
        name: "Nombre de la Categoría",
        order: "Orden",
        order_placeholder: "1",
        texts: "Información de la Categoría",
      },
      new: "Nueva categoría",
      not_found: "Categoría no encontrada, ¡por favor inténtelo de nuevo!",
      status: {
        disabled: "Deshabilitado",
        enabled: "Habilitado",
      },
      title: "Lista de Categorías",
    },
    clear_filter: "Limpiar búsqueda y filtros",
    company: {
      booking_title: "Reservas",
      bookings_title: "Horario de Reservas",
      colors_title: "Colores y Estilos",
      disclaimers_title: "Avisos Legales del Menú",
      form: {
        booking_approval: "Aprobar reservas",
        booking_interval: "Intervalo entre reservas",
        booking_max_seats: "Cantidad máxima de asientos",
        booking_toleration: "Tolerancia de la reserva",
        currency: "Moneda",
        end: "Horario Final",
        lang: "Idioma Predeterminado",
        langs: "Idiomas Disponibles",
        name: "Nombre",
        period: "Período",
        phone: "Número de Teléfono",
        pics: "Ítems con Foto",
        qrcode_bg: "Color de fondo del código QR",
        qrcode_border: "Color de borde del código QR",
        required: "Campo obligatorio",
        seats: "Asientos",
        start: "Horario Inicial",
        street_address: "Dirección",
        theme: "Color del Tema",
        timezone: "Zona Horaria de la Empresa",
        weekday: "Día de la semana",
      },
      periods_title: "Horario del Menú",
      request_error: "No se pudo cargar la información de la empresa",
      runnings_title: "Horario de Funcionamiento",
      time_title: "Información de Zona Horaria",
      title: "Empresa",
    },
    discounts: {
      columns: {
        actions: "Acciones",
        items: "Ítems",
        name: "Nombre",
        percent: "Porcentaje %",
        period: "Período",
        type: "Tipo",
      },
      dialogs: {
        delete: {
          message: "¿Realmente quieres eliminar el descuento '{{discount_name}}' ?",
          title: "Eliminar descuento",
        },
      },
      enabled: "Habilitado",
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        apply_to: "Aplicar a",
        basic_info: "Información Básica",
        discount_info: "Información del Descuento",
        percent_placeholder: "0",
      },
      items: "Ítems (Comidas / Categorías)",
      name: "Nombre",
      new: "Nuevo descuento",
      not_found: "Descuento no encontrado, ¡por favor seleccione otro e inténtelo de nuevo!",
      percent: "Porcentaje %",
      period: "Período",
      title: "Descuentos",
      type: "Tipo",
      types: {
        category: "Categoría",
        food: "Comida",
      },
    },
    filters: {
      chips_label: "Fichas de filtros activos",
      expand_label: "Expandir filtros",
      summary_label: "Resumen de filtros activos",
    },
    foods: {
      actions: {
        delete: "Eliminar",
        disable: "Deshabilitar",
        edit: "Editar",
        enable: "Habilitar",
        price: "Editar Precio",
      },
      card: {
        available_days_label: "Días disponibles",
        available_periods_label: "Períodos disponibles",
        categories_label: "Categorías",
        featured_label: "Destacado",
        featured_tooltip: "Ítem destacado",
        has_image_label: "Tiene imagen",
        has_image_tooltip: "El ítem tiene imagen",
        indicators_label: "Indicadores del ítem",
        original_price_label: "Precio original",
        price_label: "Precio",
        promo_price_label: "Precio promocional",
        quick_actions_label: "Acciones rápidas",
        status_badges_label: "Insignias de estado",
      },
      columns: {
        actions: "Acciones",
        categories: "Categoría",
        langs: "Idiomas Registrados",
        name: "Nombre",
        periods: "Períodos",
        price: "Precio",
        status: "Estado",
        weekdays: "Días de la Semana",
      },
      dialogs: {
        delete: {
          message: "¿Realmente desea eliminar el ítem '{{food_name}}'?",
          title: "Eliminar Ítem",
        },
        disable: {
          message: "¿Realmente desea deshabilitar el ítem '{{food_name}}'?",
          title: "Deshabilitar Ítem",
        },
        enable: {
          message: "¿Realmente desea habilitar el ítem '{{food_name}}'?",
          title: "Habilitar Ítem",
        },
        price: "Editar Precio",
      },
      drag_warning: "Seleccione exactamente una categoría para ordenar arrastrando los ítems",
      featured: {
        all: "All",
        featured: "Featured",
        not_featured: "Not featured",
      },
      filters: {
        availability: "Availability",
        categories: "Categorías",
        classification: "Classification",
        featured: "Destacado",
        filter_active: "filtro activo",
        filters_active: "filtros activos",
        inclusive: "Inclusive",
        periods: "Momentos del día",
        preview: "Ver menú",
        search: "Busca",
        search_text: "Search text",
        status: "Item Status",
        weekdays: "Días de la semana",
      },
      form: {
        all_days: "Todos los días",
        all_languages_required: "Todos los idiomas son obligatorios",
        all_periods: "Todos los períodos",
        availability: "Disponibilidad",
        basic_info: "Información Básica",
        categories: "Categorías",
        categorization: "Categorización",
        change_image: "Cambiar imagen",
        code: "Código",
        coffee: "Desayuno",
        create_title: "Nuevo Ítem",
        description: "Descripción",
        dine: "Cena",
        edit_title: "Editar Ítem",
        enabled: "Habilitar",
        featured: "Destacado",
        friday: "Viernes",
        image: "Imagen del ítem",
        lunch: "Almuerzo",
        monday: "Lunes",
        name: "Nombre",
        new_category: "Nueva Categoría",
        new_tag: "Nueva Etiqueta",
        no_categories: "Ninguna categoría disponible",
        no_tags: "Ninguna etiqueta disponible",
        order: "Orden",
        periods: "Períodos",
        price: "Precio",
        price_label: "Precio",
        promo_price: "Precio promocional",
        promo_price_label: "Precio promocional",
        saturday: "Sábado",
        snack: "Merienda",
        sunday: "Domingo",
        tags: "Etiquetas",
        texts: "Información del Ítem",
        thursday: "Jueves",
        tuesday: "Martes",
        wednesday: "Miércoles",
        weekdays: "Días",
      },
      grid_label: "Ítems de comida",
      new: "Nuevo Ítem",
      not_found: "¡Ítem no encontrado, por favor seleccione otro e inténtelo de nuevo!",
      periods: {
        "": "",
        all: "All",
        coffee: "Coffee",
        dine: "Dine",
        lunch: "Lunch",
        snack: "Snack",
      },
      quick_filters: {
        active: "Activos",
        featured: "Destacados",
        inactive: "Inactivos",
        on_sale: "En Promoción",
      },
      statistics: {
        disabled: "Deshabilitados",
        enabled: "Habilitados",
        featured: "Destacados",
        showing: "Mostrando",
      },
      statistics_label: "Resumen de estadísticas de comida",
      status: {
        all: "All",
        disabled: "Deshabilitado",
        enabled: "Habilitado",
      },
      title: "Lista de Ítems del Menú",
      view: {
        grid: "Cuadrícula",
        label: "Visualización",
        table: "Tabla",
      },
      weekdays: {
        "": "",
        all: "All",
        friday: "Viernes",
        monday: "Lunes",
        saturday: "Sábado",
        sunday: "Domingo",
        thursday: "Jueves",
        tuesday: "Martes",
        wednesday: "Miércoles",
      },
    },
    highlights: "Destacados",
    image: {
      error: "Algo salió mal al enviar su imagen, inténtelo de nuevo.",
      maxsize: "Esta imagen excede el tamaño máximo permitido, envíe una imagen con un tamaño máximo de 5MB.",
      remove: "Algo salió mal al eliminar su imagen, inténtelo de nuevo.",
    },
    menu: {
      bookings: "Reservas",
      categories: "Categorías",
      change_password: "Cambiar Contraseña",
      company: "Empresa",
      discounts: "Descuentos",
      foods: "Ítems",
      logout: "Salir",
      print_menu: "Imprimir Menú",
      profile: "Perfil",
      reader: "Lector de código QR",
      tags: "Etiquetas",
      users: "Usuarios",
    },
    no_dishes: "No hay platos en el menú hoy.",
    not_found: "No encontramos ningún plato según su búsqueda.",
    notifications: {
      not_supported: "Las notificaciones no son compatibles con este navegador",
    },
    reader: {
      people_count: "Cantidad de personas",
    },
    search_dish: "Busque su plato",
    stats: {
      all_time: "Histórico total",
      canceled: "Canceladas",
      canceled_subtitle: "Reservas canceladas",
      confirmed: "Confirmadas",
      confirmed_subtitle: "Reservas confirmadas",
      occupancy_rate: "Tasa de Ocupación",
      seats: "Asientos",
      today_bookings: "Reservas Hoy",
      today_subtitle: "Reservas para hoy",
      total_bookings: "Total de Reservas",
      used: "Utilizadas",
      used_subtitle: "Reservas utilizadas",
    },
    tags: {
      columns: {
        actions: "Acciones",
        langs: "Idiomas Registrados",
        name: "Nombre",
      },
      dialogs: {
        delete: {
          message: "¿Realmente desea eliminar la etiqueta '{{category_name}}'?",
          title: "Eliminar etiqueta",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        all_languages_required: "Todos los idiomas son obligatorios",
        create_title: "Nueva Etiqueta",
        edit_title: "Editar Etiqueta",
        name: "Nombre de la Etiqueta",
        texts: "Información de la Etiqueta",
      },
      new: "Nueva etiqueta",
      not_found: "¡Etiqueta no encontrada, por favor inténtelo de nuevo!",
      title: "Lista de Etiquetas",
    },
    title: "ZMenu Dashboard",
    users: {
      actions: {
        delete: "Eliminar",
        edit: "Editar",
      },
      columns: {
        actions: "Acciones",
        fullname: "Nombre Completo",
        mail: "Correo electrónico",
        scopes: "Permisos",
        username: "Nombre de usuario",
      },
      dialogs: {
        delete: {
          message: "¿Realmente desea eliminar al usuario '{{user_name}}'?",
          title: "Eliminar usuario",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        basic_info: "Información Básica",
        confirm_password: "Confirmar Contraseña",
        create_title: "Nuevo Usuario",
        edit_title: "Editar Usuario",
        fullname: "Nombre Completo",
        mail: "Correo electrónico",
        password: "Contraseña",
        permissions: "Permisos",
        scopes: "Permisos",
        security: "Seguridad",
        username: "Nombre de Usuario",
      },
      new_singular: "Nuevo Usuario",
      not_found: "¡Usuario no encontrado, por favor seleccione otro e inténtelo de nuevo!",
      profile: {
        change_password: "Cambiar Contraseña",
        title: "Perfil del usuario",
      },
      title: "Lista de usuarios",
    },
    password_scores: {
      very_weak: "Muy Débil",
      weak: "Débil",
      okay: "Aceptable",
      good: "Buena",
      strong: "Fuerte",
    },
  },
  dialogs: {
    attention: "Atención",
    cancel: "Cancelar",
    close: "Cerrar",
    confirm: "Sí",
    confirmation: "Confirmar",
    edit: "Edit",
    fail: "¡Ops!",
    gone_wrong: "¡Algo salió mal, inténtelo de nuevo!",
    invalid_login: "El inicio de sesión o la contraseña introducidos no son válidos, inténtelo de nuevo",
    login_error: "Error en el inicio de sesión. Inténtelo de nuevo.",
    not_allowed: "Este usuario no está autorizado para usar este módulo.",
    same_user: "Ya existe una cuenta registrada con el correo {{ email }}. Intente iniciar sesión con esta cuenta en lugar de asociar esta cuenta social.",
    submit: "Enviar",
    success: "Éxito",
  },
  password_scores: {
    very_weak: "Muy Débil",
    weak: "Débil",
    okay: "Aceptable",
    good: "Buena",
    strong: "Fuerte",
  },
  drag_limited_to: "Arrastre limitado a",
  footer: "hecho con amor por ZMenu ©",
  forms: {
    common: {
      price_placeholder: "0,00",
      time_placeholder: "HH:mm",
    },
  },
  gone_wrong: "¡Algo salió mal, inténtelo de nuevo!",
  loading: "Cargando",
  login: {
    email: "Correo electrónico",
    facebook: "Facebook",
    google: "Google",
    password: "Contraseña",
    sigin_apple: "Iniciar sesión con Apple",
    sigin_facebook: "Iniciar sesión con Facebook",
    sigin_google: "Iniciar sesión con Google",
    signup: "Regístrese",
    submit: "Entrar",
    username: "Usuario",
  },
  logout: "Salir",
  module: {
    disabled: "Módulo deshabilitado, contacte al equipo de ZMenu para habilitarlo.",
  },
  network: {
    back_online: "Conexión restaurada",
    offline: "Sin conexión",
    offline_error: "Error de conexión. Verifique su internet.",
  },
  of: "de",
  pdf: {
    categories: "Categorías",
    clear_all: "Limpiar todo",
    converting_category: "Convirtiendo categoría {{current}} de {{total}}...",
    description: "Seleccione las categorías que desea incluir en su menú para imprimir",
    download: "Descargar",
    download_success: "¡PDF descargado con éxito!",
    drag_to_reorder: "Arrastre para reordenar las categorías en el PDF",
    food_count: "{{count}} elementos",
    generate: "Generar PDF",
    generation_error: "Error al generar PDF",
    generation_success: "¡PDF generado con éxito!",
    include_prices: "Incluir precios",
    language: "Idioma",
    loading: "Cargando...",
    merging_pdfs: "Fusionando PDFs...",
    no_categories: "No hay categorías disponibles",
    no_categories_selected: "Seleccione al menos una categoría",
    options: "Opciones",
    preparing_menu: "Preparando menú...",
    preview: "Vista previa PDF",
    preview_html: "Vista previa HTML",
    preview_html_title: "Vista previa HTML",
    preview_title: "Vista previa del PDF",
    select_all: "Seleccionar todo",
    selected_count: "{{count}} de {{total}} categorías seleccionadas",
    settings: "Configuración del PDF",
    title: "Generar Menú PDF",
  },
  signup: {
    complete: "Complete su perfil",
    confirm_password: "Confirme la contraseña elegida",
    email: "Correo electrónico de contacto",
    name: "Nombre completo",
    password: "Elija su contraseña",
    phone: "Teléfono / Celular",
    submit: "Registrar",
    title: "Regístrese",
  },
  validation: {
    email: "Email",
    error: "Error",
    maxLength: "Max length",
    minLength: "Min length",
    pattern: "Pattern",
    phone: "Phone",
    required: "Required",
  },
};